var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{class:'text-'+ _vm.color,attrs:{"name":_vm.icon,"data-toggle":"tooltip","data-title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }